import React, { ChangeEvent, useEffect, useId, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup, Radio } from "@mui/material";

interface SnCheckBoxProps {
  defaultValue?: string;
  label?: string;
  onValueChanged?: (value: string) => void;
  isReadOnly?: boolean;
  inputRef?: any;
  isSearchPanel?: boolean;
  onFocus?: (target: string) => void;
}

const SnCheckBox = React.memo(
  ({
    defaultValue = "N",
    label,
    onValueChanged,
    isReadOnly = false,
    inputRef,
    isSearchPanel = false,
    onFocus,
  }: SnCheckBoxProps) => {
    const [value, setValue] = useState(defaultValue === "Y");
    const checkboxId = useId();

    const fetchDefaultValue = async () => {
      try {
        if (defaultValue !== undefined) {
          setValue(defaultValue === "Y");
        }
      } catch (error: any) {}
    };

    useEffect(() => {
      fetchDefaultValue();
    }, [defaultValue]);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked;
      const newValue = checked ? "Y" : "N";
      setValue(checked);
      onValueChanged?.(newValue);
    };

    const handleKeyDown = async (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
        await (e.target as HTMLInputElement).blur();
        if (isSearchPanel) {
          e.preventDefault();
          onFocus && onFocus("current");
        } else {
          e.preventDefault();
          onFocus && onFocus("next");
        }
      } else if (e.key === "Tab") {
        await (e.target as HTMLInputElement).blur();
        e.preventDefault();
        onFocus && onFocus("next");
      }
    };

    return (
      <FormGroup>
        <FormControlLabel
          htmlFor={checkboxId}
          label={label}
          control={
            <Checkbox
              id={checkboxId}
              inputRef={inputRef}
              checked={value}
              disabled={isReadOnly}
              onKeyDown={handleKeyDown}
              onChange={handleChange}
              sx={{
                height: "30px",
                "& .MuiSvgIcon-root": {
                  fontSize: 22,
                },
              }}
            />
          }
          sx={{
            "& .MuiTypography-root": {
              fontSize: 13,
            },
          }}
        />
      </FormGroup>
    );
  }
);

export default SnCheckBox;
